module.exports = __webpack_public_path__ + "static/media/abhijeetpatil.4a6ad027.png";